export default {"src":"/_next/static/media/house-paint.4111684f.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};